<template>
	<div>
		  <Breadcrumbs main="Technicians" title="Add Technician" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<router-link to="/technicians" class="btn btn-primary float-end"><i
                                            class='bx bx-chevrons-left'></i> Back</router-link>
										<!-- <a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
							   	</div>
							</div>
 
							<form  @submit.prevent="addTechnician" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Technician Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="name"/>
												<span class="validate-error" v-if="errors.name">
													{{ errors.name[0] }}
												</span>
											</div>
										</div>

                                        <div class="col-md-4 form-group">
                                            <label class="control-label">Mobile No.<span class="text-danger">*</span></label>
                                            <input class="form-control" type="number" placeholder="" v-model="mobile" @input="restrictMobileInput" minlength="10" maxLength="10"/>
											<span class="validate-error" v-if="errors.mobile">
												{{ errors.mobile[0] }}
											</span>
                                        </div>
									
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Username<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="username"/>
												<span class="validate-error" v-if="errors.user_name">
													{{ errors.user_name[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												 <label class="control-label">Password<span class="text-danger">*</span></label>
                                                <input class="form-control" type="password" placeholder="" v-model="password"/>
												<span class="validate-error" v-if="errors.password">
													{{ errors.password[0] }}
												</span>
											</div>
										</div>

                                        <div class="col-md-4">
											<div class="mb-3">
												 <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                                                <input class="form-control" type="text" placeholder="" v-model="password_confirmation"/>
												<span class="validate-error" v-if="errors.password_confirmation">
													{{ errors.password_confirmation[0] }}
												</span>
											</div>
										</div>

                                        <h4 class="mt-4 mb-3">Incentive Rates</h4>

                                        <!-- <div v-for="product in products" :key="product.id" class="card mb-3">
                                            <div class="card-header fw-bold">{{ product.name }}</div>
                                            <div class="card-body row g-3">
                                                <div class="col-md-2" v-for="type in types" :key="type.id">
                                                    <label class="form-label">{{ type.label }}</label>
                                                    <input type="number" min="0" class="form-control"/>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div v-for="product in all_products" :key="product.id" class="d-flex align-items-center justify-content-between border rounded p-3 mb-3">
											<div class="fw-bold" style="width: 160px;">{{ product.product_name }}</div>

											<div class="d-flex flex-grow-1 gap-3">
												<div class="flex-fill">
													<label class="form-label mb-1">New</label>
													<input type="number" min="0" class="form-control"
														@input="updateProductAmount(product, 'new', $event.target.value)"
													/>
												</div>

												<div class="flex-fill">
													<label class="form-label mb-1">Repair</label>
													<input type="number" min="0" class="form-control"
														@input="updateProductAmount(product, 'repair', $event.target.value)"
													/>
												</div>

												<div class="flex-fill">
													<label class="form-label mb-1">Replacement</label>
													<input type="number" min="0" class="form-control"
														@input="updateProductAmount(product, 'replacement', $event.target.value)"
													/>
												</div>
											</div>
										</div>
									</div>


									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit">Save</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script setup>
import { get, post } from '@/utils/api';
import { routes } from '@/constants/routes';
import Swal from '@/utils/swal';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import 'core-js/modules/es.array.includes'; 
import { goBack } from '@/utils/urlHider';

const router = useRouter();

const name = ref("");
const mobile = ref("");
const username = ref("");
const password = ref("");
const password_confirmation = ref("");
const all_products = ref([]);
const products = ref([]);
const types = 	[
					{ id: 1, label: 'New' },
					{ id: 2, label: 'Repair' },
					{ id: 3, label: 'Replacement' }
				];
const errors = ref({});
				
const fetchProducts = () => {

	get(routes.AllProducts, {}, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                all_products.value = response.data.data;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const updateProductAmount = (product, type, amount) => {
    addProductIfNotExists(product);
    const existing = products.value.find(p => p.product_id === product.id);
    if (existing) {
        // Convert empty string or null to 0, otherwise convert to number
        existing.incentives[type] = amount === '' || amount === null ? 0 : Number(amount);
    }
};


const addProductIfNotExists = (product) => {
    const existing = products.value.find(p => p.product_id === product.id);
    if (!existing) {
        products.value.push({
            product_id: product.id,
            incentives: { new: null, repair: null, replacement: null }
        });
    }
};

const restrictMobileInput = (event) => {
	// Remove any non-digit characters and limit to 10 digits
	const value = event.target.value.replace(/\D/g, '').slice(0, 10);
	mobile.value = value;
};

const addTechnician = () => {
    // Clear previous errors
    errors.value = {};

    const formData = new FormData();
    formData.append('name', name.value);
    formData.append('user_name', username.value);
    formData.append('mobile', mobile.value);
    formData.append('password', password.value);
    formData.append('password_confirmation', password_confirmation.value);

    // Process products data to convert null incentives to 0
    // We need to send ALL products, not just the ones that were interacted with
    const processedProducts = all_products.value.map(product => {
        // Find if this product has been interacted with
        const existingProduct = products.value.find(p => p.product_id === product.id);
        
        return {
            product_id: product.id,
            incentives: {
                new: existingProduct ? (existingProduct.incentives.new === null ? 0 : existingProduct.incentives.new) : 0,
                repair: existingProduct ? (existingProduct.incentives.repair === null ? 0 : existingProduct.incentives.repair) : 0,
                replacement: existingProduct ? (existingProduct.incentives.replacement === null ? 0 : existingProduct.incentives.replacement) : 0
            }
        };
    });

	formData.append('products', JSON.stringify(processedProducts));

    // Debug: Log what we're sending
    console.log('Sending products:', processedProducts);
    console.log('All products count:', all_products.value.length);
    console.log('Processed products count:', processedProducts.length);

	post(routes.AddTechnician, formData, false)
		.then((response) => {
			if (response.status === 200) {
                Swal.fire('', response.data.message || 'Technician added successfully', 'success');
				router.push({ name: 'technicians'});
            } else {
                Swal.fire('', response.data.message || 'Failed to add technician', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                // Handle validation errors - message can be string or object
                const message = error.response.data.message;
                
                if (typeof message === 'string') {
                    // If message is a string, show it directly
                    errors.value = {};
                    Swal.fire('Validation Error', message, 'error');
                } else if (typeof message === 'object' && message !== null) {
                    // If message is an object with field errors
                    errors.value = message;
                    
                    // Show SweetAlert with validation errors
                    let errorMessages = [];
                    Object.keys(message).forEach(field => {
                        if (Array.isArray(message[field])) {
                            errorMessages.push(`${field}: ${message[field].join(', ')}`);
                        } else {
                            errorMessages.push(`${field}: ${message[field]}`);
                        }
                    });
                    Swal.fire('Validation Error', errorMessages.join('<br>'), 'error');
                } else {
                    errors.value = {};
                    Swal.fire('Validation Error', 'Validation failed', 'error');
                }
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});

};


onMounted(() => {
	fetchProducts();
})

const handleGoBack = () => {
	const success = goBack(router);
	if (!success) {
		// If no history, go to dashboard as fallback
		router.push({ name: 'defaultRoot' });
	}
};

</script>